var render, staticRenderFns
import script from "./P2PFilters.vue?vue&type=script&lang=js"
export * from "./P2PFilters.vue?vue&type=script&lang=js"
import style0 from "./P2PFilters.vue?vue&type=style&index=0&id=c741d300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c741d300",
  null
  
)

export default component.exports